import { useState } from "react";
import { ResidentialCalculator } from "./ResidentialCalculator";
import { CommercialCalculator } from "./CommercialCalculator";
import { Calculator, Home, Building2 } from "lucide-react";

export const CalculatorSection = ({ onGetQuote }) => {
  const [activeTab, setActiveTab] = useState("residential");

  return (
    <section id="tonnage-calculator" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-brand-50 rounded-full px-4 py-1.5 mb-5 border border-brand-100">
            <Calculator className="w-4 h-4 text-brand-600" />
            <span className="text-sm font-medium text-brand-700">AC Tonnage Calculator</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Calculate Your AC Tonnage Requirement
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto text-base">
            Use our HVAC tonnage calculator for accurate air conditioning load calculation. Get precise AC tonnage recommendations for residential and commercial spaces.
          </p>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-slate-100 rounded-xl p-1.5">
            <button
              onClick={() => setActiveTab("residential")}
              className={`flex items-center gap-2 px-6 sm:px-8 py-3 rounded-lg text-sm font-medium transition-all duration-250 ${
                activeTab === "residential"
                  ? "bg-brand-600 text-white shadow-md"
                  : "text-slate-600 hover:text-brand-600 hover:bg-white"
              }`}
            >
              <Home className="w-4 h-4" />
              <span>Residential AC</span>
            </button>
            <button
              onClick={() => setActiveTab("commercial")}
              className={`flex items-center gap-2 px-6 sm:px-8 py-3 rounded-lg text-sm font-medium transition-all duration-250 ${
                activeTab === "commercial"
                  ? "bg-brand-600 text-white shadow-md"
                  : "text-slate-600 hover:text-brand-600 hover:bg-white"
              }`}
            >
              <Building2 className="w-4 h-4" />
              <span>Commercial HVAC</span>
            </button>
          </div>
        </div>

        {/* Calculator Content */}
        {activeTab === "residential" ? (
          <ResidentialCalculator onGetQuote={onGetQuote} />
        ) : (
          <CommercialCalculator onGetQuote={onGetQuote} />
        )}
      </div>
    </section>
  );
};
